export const ProjectCategories = [
    { code: 'automotive_corporate', name: 'Automotive - Corporate' },
    { code: 'automotive_equipment', name: 'Automotive - Equipment' },
    { code: 'automotive_rental', name: 'Automotive - Rental' },
    { code: 'b2b_healthpharma', name: 'B2B - Health Pharma' },
    { code: 'b2b_industrial', name: 'B2B - Industrial' },
    { code: 'b2b_office', name: 'B2B - Office' },
    { code: 'b2b_saas', name: 'B2B - SAAS' },
    { code: 'bfsi_healthcare', name: 'BFSI - Healthcare' },
    { code: 'bfsi_nohealth', name: 'BFSI - No Health' },
    { code: 'charity', name: 'Charity' },
    { code: 'education', name: 'Education' },
    { code: 'energy', name: 'Energy' },
    { code: 'government', name: 'Government' },
    { code: 'housing_rentalpurchase', name: 'Housing - Rental Purchase' },
    { code: 'luxury_clothesaccessories', name: 'Luxury - Clothes Accessories' },
    { code: 'luxury_jewelrywatches', name: 'Luxury - Jewelry Watches' },
    { code: 'luxury_nowearable', name: 'Luxury - No Wearable' },
    { code: 'media', name: 'Media' },
    { code: 'other', name: 'OTHER' },
    { code: 'paas_consumerservice', name: 'PAAS - Consumer Service' },
    { code: 'paas_entertainment', name: 'PAAS - Entertainment' },
    { code: 'paas_gambling', name: 'PAAS - Gambling' },
    { code: 'paas_socialnetworks', name: 'PAAS - Social Networks' },
    { code: 'partners', name: 'Partners' },
    { code: 'retail_bagsuitcases', name: 'Retail - Bag Suitcases ' },
    { code: 'retail_clothesaccessories', name: 'Retail - Clothes Accessories' },
    { code: 'retail_cosmetics', name: 'Retail - Cosmetics' },
    { code: 'retail_entertainment', name: 'Retail - Entertainment' },
    { code: 'retail_footwear', name: 'Retail - Footwear' },
    { code: 'retail_healthcare', name: 'Retail - Healthcare' },
    { code: 'retail_healthcare_glasses', name: 'Retail - Healthcare Glasses' },
    { code: 'retail_home_flowergifts', name: 'Retail - Home - Flower Gifts' },
    { code: 'retail_home_furnishingsdiy', name: 'Retail - Home - furnishings DIY' },
    { code: 'retail_jewelrywatches', name: 'Retail - Jewelry Watches' },
    { code: 'retail_largeretailer', name: 'Retail - Large Retailer' },
    { code: 'retail_pets', name: 'Retail - Pets' },
    { code: 'retail_premiumgroceries', name: 'Retail - Premium Groceries' },
    { code: 'retail_sportequipment', name: 'Retail - Sport Equipment' },
    { code: 'retail_supermarket', name: 'Retail - Supermarket' },
    { code: 'retail_tech', name: 'Retail - Tech' },
    { code: 'retail_underwear', name: 'Retail - Underwear' },
    { code: 'retail_wholesale', name: 'Retail - Wholesale' },
    { code: 'telecom', name: 'Telecom' },
    { code: 'tourism_food', name: 'Tourism - Food' },
    { code: 'tourism_hotelparks', name: 'Tourism - Hotel Parks' },
    { code: 'tourism_transport', name: 'Tourism - Transport' },
    { code: 'tourism_tripplanner', name: 'Tourism - Trip Planner' },
];
//# sourceMappingURL=project.category.js.map